module.exports = __webpack_public_path__ + "img/aliev.4433da21.jpg";